<template>
  <div>
    <v-btn
      @click.stop="dialog = true"
      class="py-1 pr-1 btnClass"
      depressed
      solo
      outlined
      small
      rounded
    >
      <img
        :src="imageUrl(selectedItem)"
        height="21"
        width="21"
        class="mx-2 mb-1 my-1"
      />
      <!-- grey--text text--darken-2 -->
      <span class="px-2 textWidth"> {{ labelText(selectedItem) }}</span>

      <v-icon small class="ml-1" color="primary">mdi-menu-down</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="98%" width="350">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2 d-flex flex-row">
          <div>Filter CL Types</div>
          <v-spacer></v-spacer>
          <v-btn icon color="primary" @click.stop="dialog = false">
            <v-icon color="primary">mdi-close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <!-- {{ optionsInSet }} -->
          <v-list hover>
            <v-list-item-group v-model="selectedItem" color="primary">
              <v-list-item v-for="(type, index) in optionKeys" :key="index">
                <v-list-item-icon>
                  <img
                    :src="imageUrl(index)"
                    height="23"
                    width="23"
                    class="mr-3"
                  />
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    ><span v-text="labelText(index)"></span
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// * note : this holds on object that contains all the labels and images used above
import FilterDictionary from "@/assets/js/cls/FilterDictionary";
import HardLinksMixin from "@/assets/js/HardLinksMixin";

export default {
  name: "TypeSelect",
  mixins: [HardLinksMixin],
  props: {
    external: {
      type: String,
      default: "ALL",
    },
    // options: null,
  },
  data: function () {
    return {
      // r: 1,
      imagePath: "/images/icons/type/",
      selectedItem: 0,
      dialog: false,
    };
  },
  computed: {
    optionKeys: function () {
      return Object.keys(FilterDictionary.filterOptions.type);
    },

    // selectedObj: function () {
    //   return this.optionKeys[this.selectedItem];
    // },
  },
  methods: {
    // convenience function - takes an index from the optionKeys array and finds the key
    typeObjForIndex(index) {
      let key = this.optionKeys[index];
      return this.typeObjForKey(key);
    },
    // uses a key and gets a lens type object from FilterDictionary.lensTypeOptions object
    typeObjForKey(key) {
      return FilterDictionary.filterOptions.type[key];
    },
    labelText(index) {
      let obj = this.typeObjForIndex(index);
      //console.log(obj);

      return obj?.label ? obj.label : null;
    },

    imageUrl(index) {
      let obj = this.typeObjForIndex(index);
      let img = obj?.image;
      if (!img) return null;
      return `${this.CL_TYPE_DIR}/${img}_icon_active.svg`;
    },
    setSelectedItemForKey(key) {
      if (!key) {
        this.selectedItem = 0;
        return;
      }
      let index = this.optionKeys.indexOf(key.toUpperCase());
      if (index != this.selectedItem) this.selectedItem = index;
    },
  },

  watch: {
    selectedItem(index) {
      this.dialog = false;
      // console.log(index);
      //   let val = this.optionKeys[index];

      // console.log("emitting ", val);
      this.$emit("type", this.optionKeys[index]);
      this.$emit("image", this.imageUrl(this.selectedItem));
    },
    external(val) {
      // for when the val is set externally by the prop
      this.setSelectedItemForKey(val);
    },
  },

  mounted: function () {
    this.setSelectedItemForKey(this.external);
  },
};
</script>

<style scoped>
.grayText {
  color: #383838;
}
.disabledText {
  color: rgb(150, 150, 150);
}
.grayBorder.v-btn {
  border: thn solid #636363;
}
.fb-btn.v-btn--outlined {
  border: thin solid #cccccc;
}
.activeBtn {
  background-color: pink;
  color: pink;
}
.pointer {
  cursor: pointer;
}
.littleText {
  font-size: 8pt;
}
.btnClass {
  background-color: #ffffff80;
  border: thin solid #b6b6b6;
}
.textWidth {
  min-width: 155px;
}
</style>
